<template>
  <div class="poster-wrapper">
    <div ref="poster" class="poster-container">
      <div class="course-cover">
        <img
          v-if="courseInfo.cover_url"
          ref="cover"
          :src="courseInfo.cover_url"
          @load="onload(1)"
          alt=""
        />
      </div>
      <div class="course-name">
        {{
          courseInfo.course_name && courseInfo.course_name.length > 30
            ? courseInfo.course_name.slice(0, 30) + "..."
            : courseInfo.course_name
        }}
      </div>
      <div class="price">
        <span class="symbol" v-if="courseInfo.goods && courseInfo.goods.price"
          >¥</span
        >{{ price }}
      </div>
      <div class="teacher-info">
        <img v-if="userInfo.avatar" :src="userInfo.avatar" alt="" />
        <div class="info">
          <div class="teacher-name">{{ userInfo.nickname }}</div>
          <!-- <div v-show="showDesc" class="teacher-desc ellipsis">
            {{ userInfo.profile }}
          </div> -->
        </div>
      </div>
      <div class="qr-area">
        <div class="logo">
          <img v-if="logoUrl" :src="logoUrl" @load="onload(3)" alt="" />
        </div>
        <div class="center">
          <div class="top">
            <div>长按识别二维码</div>
            <img src="../../../assets/images/poster/hand.png" alt="" />
          </div>
          <div class="bottom">来魔果上好课！</div>
        </div>
        <div class="qr-img">
          <img v-if="qrCodeUrl" :src="qrCodeUrl" alt="" @load="onload(4)" />
        </div>
      </div>
    </div>
    <create-qr-code
      ref="qrCode"
      :url="courseDetailUrl"
      :logo-url="logoUrl"
      :canvas-width="140"
      :canvas-height="140"
      @create-qr-code="getQrCodeUrl"
    />
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import {
  saveFile,
  getUploadSignature,
} from "@saas/service-api/src/material/index.js";
import shareSdk from "@saas/components/src/utils/share";
import CreateQrCode from "@saas/components/src/components/CreateQrCode";

export default {
  components: { CreateQrCode },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    // qrCodeUrl: {
    //   type: String,
    //   default: "",
    // },
  },
  watch: {},
  data() {
    return {
      dialog: false,
      loading: false,
      logoUrl: process.env.VUE_APP_CDN_URL + "/cdn/static/images/favicon.ico",
      // 海报地址
      posterUrl: "",
      qrCodeUrl: "",
      imgLoadCount: 0,
      timer: null,
      isLoadCoverUrl: false,
    };
  },
  computed: {
    posterName() {
      return "课程海报-" + this.courseInfo.course_name;
    },
    price() {
      if (this.courseInfo.goods && this.courseInfo.goods.price) {
        return (this.courseInfo.goods.price / 100).toFixed(2);
      } else {
        return "免费";
      }
    },
    userInfo() {
      return this.$store.getters.user || {};
    },
    showDesc() {
      return this.userInfo.profile;
    },
    courseDetailUrl() {
      return (
        process.env.VUE_APP_SAAS_WEB_URL +
        "/product-detail/" +
        this.$route.params.id
      );
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    onload(type) {
      if (type === 1) {
        this.isLoadCoverUrl = true;
      }
      console.log("加完了》〉》〉》〉》", type);
      this.imgLoadCount++;
      console.log("imgLoadCount", this.imgLoadCount);

      // if (this.imgLoadCount === 3) {
      //   this.createPoster();
      // }
    },
    getQrCodeUrl(url) {
      this.qrCodeUrl = url;
    },
    checkLoad() {
      if (this.posterUrl) {
        return;
      }
      if (this.imgLoadCount >= 3 && this.isLoadCoverUrl) {
        this.createPoster();
      } else {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (this.imgLoadCount >= 3 && this.isLoadCoverUrl) {
            this.createPoster();
            clearInterval(this.timer);
          }
        }, 500);
      }
    },

    open() {
      this.dialog = true;
    },
    // 创建海报
    createPoster() {
      console.log("创建海报了");
      if (this.loading) {
        return;
      }
      this.$nextTick(() => {
        this.loading = true;
        const dom = document.querySelector(".poster-container");
        console.log("dom", dom);

        // 解决文字偏移问题
        // const style = document.createElement('style')
        // document.head.appendChild(style)
        // style.sheet?.insertRule('body > div:last-child img { display: inline-block; }')
        html2canvas(dom, {
          backgroundColor: null,
          width: dom.clientWidth,
          height: dom.clientHeight,
          scrollX: 0,
          scrollY: 0,
          scale: 4,
          useCORS: true,
          onclone: (clone) => {
            const dom = clone.querySelector(".poster-container");
            dom.style.borderRadius = "20px";
            dom.style.overflow = "hidden";
            dom.style.backgroundColor = "transparent";
            // clone.querySelector('body > div:last-child img').style.display = 'inline-block'
          },
        })
          .then((canvas) => {
            try {
              console.log("canvas>>>>>", canvas);

              const dataUrl = canvas.toDataURL("image/png");
              const file = this.convertBase64ToFile(
                dataUrl,
                this.posterName + ".png"
              );
              console.log("file", file);
              const fileData = {
                raw: file,
                name: this.posterName + ".png",
                url: "",
                percentage: 0,
                status: 0,
                cancelSource: null,
                taskId: "",
              };
              console.log("开始上传", fileData);

              this.uploadPoster(fileData);
            } catch (error) {
              this.loading = false;
            }
          })
          .catch((err) => {
            this.loading = false;
            console.log("err", err);
          });
      });
    },
    downloadPoster() {
      if (this.posterUrl) {
        const img = new Image();
        img.src = this.posterUrl;
        img.onload = () => {
          // 下载
          const a = document.createElement("a");
          a.href = this.posterUrl;
          a.download = this.posterName + ".png";
          a.click();
          // 销毁元素
          a.remove();
        };
      } else {
        this.$message.error("海报正在上传中，请稍后重试");
      }
    },
    // 上传海报
    uploadPoster(fileData) {
      console.log("fileData", fileData);
      getUploadSignature({
        fileName: fileData.name,
        materialType: 99,
      })
        .then((res) => {
          if (res.code === 1) {
            fileData.cos = cosUploadFile(
              {
                file: fileData.raw,
                fileName: fileData.name,
                type: 99, //
              },
              {
                ...res.data,
              },
              {
                onFileFinish: (err, data, options) => {
                  console.log("onFileFinish-data", data);

                  if (data && data.statusCode === 200) {
                    console.log("onFileFinish-data", data);
                    const location = data.Location;
                    const arr = location.split("/");
                    arr.shift();
                    this.posterUrl =
                      "https://cdn.moguocdn.com/" + arr.join("/");
                    // this.posterUrl = data.Location.startsWith("https://")
                    //   ? data.Location
                    //   : "https://" + data.Location;
                    this.$emit("getPosterUrl", this.posterUrl);
                    this.loading = false;
                  } else {
                    this.loading = false;
                    console.log(err);
                  }
                },
              }
            );
          } else {
            this.loading = false;
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    convertBase64ToFile(data, name) {
      if (data) {
        const base64String = data.split(",")[1]; // 去掉数据 URI 的前缀
        const byteCharacters = atob(base64String);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" }); // 根据实际情况调整 MIME 类型
        return new File([blob], name, { type: "image/png" });
      } else {
        return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.course-poster ::v-deep {
  .el-dialog {
    border-radius: 20px !important;
    background-color: unset;
    // overflow: hidden;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }
}
.poster-wrapper {
  position: fixed;
  top: -1000px;
}
.poster-container {
  width: 300px;
  height: 396px;
  background: url("../../../assets/images/poster/bg.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  padding: 20px 20px 26px 20px;
  background-color: transparent;
  .course-cover {
    width: 260px;
    height: 146px;
    border-radius: 16px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .course-name {
    height: 40px;
    margin-top: 10px;
    font-weight: 500;
    font-size: 15px;
    color: #0d1400;
    line-height: 20px;
    overflow: hidden;
  }
  .price {
    margin-top: 7px;
    font-weight: 800;
    font-size: 16px;
    color: #f03349;
    line-height: 20px;
    .symbol {
      font-weight: 800;
      font-size: 11px;
      color: #f03349;
      line-height: 12px;
    }
  }
  .teacher-info {
    width: 100%;
    height: 54px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.6);
    margin-top: 6px;
    img {
      width: 34px;
      height: 34px;
      margin-right: 8px;
      border-radius: 6px;
    }
    .info {
      .teacher-name {
        font-weight: 600;
        font-size: 12px;
        color: #000000;
        line-height: 17px;
      }
      .teacher-desc {
        margin-top: 2px;
        font-weight: 400;
        font-size: 11px;
        color: #515350;
        line-height: 16px;
      }
    }
  }
  .qr-area {
    margin-top: 27px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    .logo {
      width: 38px;
      height: 38px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .center {
      flex: 1;
      margin-left: 6px;
      .top {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        div {
          font-weight: 400;
          font-size: 10px;
          color: #515350;
          line-height: 18px;
          margin-right: 5px;
        }
        img {
          width: 17px;
          height: 18px;
        }
      }
      .bottom {
        margin-top: 1px;
        font-weight: 500;
        font-size: 13px;
        color: #0d1400;
        line-height: 18px;
      }
    }
    .qr-img {
      width: 42px;
      height: 42px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.btn-area {
  width: 100%;
  height: 105px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 26px;
  align-items: center;
  background: #fff;
  margin-top: -1px;
  border-radius: 0 0 20px 20px;
  .btn-item {
    cursor: pointer;
    width: 50px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 50px;
      height: 50px;
    }
    .text {
      margin-top: 6px;
      font-weight: 400;
      font-size: 12px;
      color: #0d1400;
      line-height: 17px;
    }
  }
}
.close-img {
  width: 26px;
  height: 26px;
  cursor: pointer;
  position: absolute;
  left: 50%;
  bottom: -46px;
  transform: translateX(-50%);
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
